import { render } from "./Loading.vue?vue&type=template&id=440f028a&scoped=true&ts=true"
import script from "./Loading.vue?vue&type=script&setup=true&lang=ts"
export * from "./Loading.vue?vue&type=script&setup=true&lang=ts"

import "./Loading.vue?vue&type=style&index=0&id=440f028a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src609605036/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-440f028a"],['__file',"src/components/agsrs/Loading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "440f028a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('440f028a', __exports__)) {
    console.log('reload')
    api.reload('440f028a', __exports__)
  }
  
  module.hot.accept("./Loading.vue?vue&type=template&id=440f028a&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('440f028a', render)
  })

}


export default __exports__